import { Pipe, PipeTransform } from '@angular/core';
import {TermsService} from "../services/terms.service";
import {TERMINOLOGY} from "../../../assets/terminology/default";

@Pipe({
  name: 'term',
  pure: true // For performance, since terms don't change at runtime
})
export class TermPipe implements PipeTransform {
  constructor(private termsService: TermsService) {}

  transform(key: string): string {
    return this.termsService.getTerm(key as keyof typeof TERMINOLOGY) || `[${key}]`;
  }
}
